import { useState } from "react";
import { PackageBuilder } from "./PackageBuilder";
import { PackageHistory } from "./PackageHistory";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { AlertTriangle } from "lucide-react";

export function MailPackagesPage() {
  const [refreshHistory, setRefreshHistory] = useState(0);

  const handlePackageSaved = () => {
    setRefreshHistory(prev => prev + 1);
  };

  return (
    <div className="container mx-auto p-6 space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold">Mail Package Builder</h1>
          <p className="text-muted-foreground mt-1">
            Prepare complete document packages for mailing
          </p>
        </div>
      </div>

      <Alert variant="destructive" className="mb-6">
        <AlertTriangle className="h-4 w-4" />
        <AlertDescription>
          <strong>Important:</strong> The cover letter currently has incorrect figures and numbers. 
          DO NOT USE until these calculations are corrected.
        </AlertDescription>
      </Alert>

      <Tabs defaultValue="builder" className="w-full">
        <TabsList>
          <TabsTrigger value="builder">New Package</TabsTrigger>
          <TabsTrigger value="history">Package History</TabsTrigger>
        </TabsList>

        <TabsContent value="builder" className="space-y-4">
          <PackageBuilder onPackageSaved={handlePackageSaved} />
        </TabsContent>

        <TabsContent value="history">
          <PackageHistory key={refreshHistory} />
        </TabsContent>
      </Tabs>
    </div>
  );
}
